import { Button } from "@src/appV2/redesign/components/Button";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

import { DialogFooter } from "../../../components/DialogFooter";

interface BreakActionConfirmationProps {
  modalState: UseModalState;
  action: "break-start" | "break-end" | "break-skip";
  onConfirm: () => void;
  onCancel: () => void;
}

function getConfirmationContent(action: "break-start" | "break-end" | "break-skip") {
  switch (action) {
    case "break-start": {
      return {
        title: "Are you sure you want to start your break?",
        illustrationType: "break" as const,
      };
    }

    case "break-end": {
      return {
        title: "Are you sure you want to end your break?",
        illustrationType: "break" as const,
      };
    }

    case "break-skip": {
      return {
        title: "Are you sure you want to skip break?",
        illustrationType: "break" as const,
      };
    }

    default: {
      return {
        title: "Are you sure?",
        illustrationType: "break" as const,
      };
    }
  }
}

export function BreakActionConfirmation(props: BreakActionConfirmationProps) {
  const { modalState, action, onConfirm, onCancel } = props;

  const { title, illustrationType } = getConfirmationContent(action);

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" sx={{ paddingTop: 10 }} onClose={onCancel}>
          <Button fullWidth variant="contained" size="large" onClick={onConfirm}>
            Continue
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent illustrationType={illustrationType} title={title} />
    </BottomSheet>
  );
}
